import { dateUtil } from '../../library/';

import { yearFormatter,monthOnlyFormatter, dayOnlyFormatter } from '../../library/GraphFunctions';

export  function getDrilldownLabel(depth,date, intl) {

  let dUtil=dateUtil[depth];

  let drillDownDate = null;

  if (dUtil && date) {
    drillDownDate = intl.formatDate(date, dUtil);
  } else {
    drillDownDate = intl.formatMessage({id:"allYears"});
  }

  return drillDownDate;

}


export function buildDrillDownList(period, year, month,day) {
  let arr = [];

  arr.push(period);

    if (year)
      arr.push(year);

    if (month)
      arr.push(month);

    if (day)
      arr.push(day);

    return arr;
  }



// Funzione che calcola il valore del drilldown (la sua profondità) in base ai
// parametri forniti dal router, determinando il valore del currentDrillDown.
// Il valore presente nello stato non sempre è possibile usarlo
// es. nella componentWillReceiveProps(..)

export function calculateDrilldown(routeParams) {
  let currentDrillDown = 0;
  let fields = ["year", "month", "day"];
  fields.forEach(function(field) {
    // Sfrutto il fatto che i campi di un oggetto json possono essere acceduti
    // come indici di un array (hashtable).
    if (routeParams[field]) currentDrillDown++;
  })

  return currentDrillDown;

}


export function manageDrillDown(period, date) {
	//console.log("manageDrillDown");
	//console.dir(period);
	//console.dir(date);
	var ddUrl = period;
	switch (period) {
		case "monthly":
			ddUrl += '/' + (date > 0 ? yearFormatter(date) : '');
			break;
		case "daily":
			ddUrl += '/' + yearFormatter(date) + '/' + monthOnlyFormatter(date);
			break;
		case "hourly":
			ddUrl += '/' +
				yearFormatter(date) +
				'/' + monthOnlyFormatter(date) +
				'/' + dayOnlyFormatter(date);

			break;
      default:
      break;
	}
	return ddUrl;

}


export function drillDownObject(period, date) {

	var ddUrl = [];
	ddUrl.push(period);

	switch (period) {
		case "monthly":
			if (date > 0)
				ddUrl.push(yearFormatter(date));
			break;
		case "daily":
			ddUrl.push(yearFormatter(date));
			ddUrl.push(monthOnlyFormatter(date));
			break;
		case "hourly":
			ddUrl.push(yearFormatter(date));
			ddUrl.push(monthOnlyFormatter(date));
			ddUrl.push(dayOnlyFormatter(date));
			break;
    default:
      break;
	}
	return ddUrl;

}

export function buildDrillDownTitle(ddArray) {

	switch (ddArray[0]) {
		case 'yearly':
			break;
		default:
			break;
	}

}


export function buildDrillDownPath(ddArray) {
	var ddPath = ddArray[0];

	for (var i = 1; i < ddArray.length; i++)
		ddPath += '/' + ddArray[i];

	return ddPath;
}



// WEBPACK FOOTER //
// ./src/components/ChartPanel/Utils.js